import * as React from 'react';
import { BaseService } from '@services/BaseService';
import { NavItem } from './_components/nav-item/nav-item';
import { Logout } from '../auth';
import * as classes from './side-drawer.scss';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { Role } from '@models/Roles';
import SideDrawerRoutes from './sidedrawer-routes';

export interface Route {
  name: string;
  friendlyName: string;
  path: string;
  isActive: boolean;
  children: Array<Route>;
  allowedRoles: Array<string>;
}

export interface SidedrawerProps extends RouteComponentProps<{}> {
  toggleSidebar: () => void;
}

export interface SidedrawerState {
  mainRoutes: Array<Route>;
}

export class SidedrawerComponent extends React.Component<SidedrawerProps, SidedrawerState> {
  state = {
    mainRoutes: SideDrawerRoutes
  };

  setInactive(routes: Array<Route>) {
    const newRoutes = routes.map(route => {
      route.isActive = false;

      if (route.children.length) {
        route.children = this.setInactive(route.children);
      }

      return route;
    });

    return newRoutes;
  }

  setActive(routes: Array<Route>, name: string) {
    const newRoutes = routes.map(route => {
      route.isActive = route.name === name;

      if (route.children.length) {
        route.children = this.setActive(route.children, name);
      }

      return route;
    });

    return newRoutes;
  }

  setParentsActive(routes: Array<Route>) {
    const newRoutes = routes.map(route => {
      route.isActive = this.checkForActiveChild(route);
      route.children = this.setParentsActive(route.children);

      return route;
    });

    return newRoutes;
  }

  checkForActiveChild(route: Route): boolean {
    return (
      route.isActive ||
      route.children.some(childRoute => childRoute.isActive) ||
      route.children.filter(childRoute => this.checkForActiveChild(childRoute)).length > 0
    );
  }

  updateActiveRoutes = (routeName: string) => {
    this.setState(prevState => {
      let newRoutes: Array<Route> = this.setInactive(prevState.mainRoutes);
      newRoutes = this.setActive(newRoutes, routeName);
      newRoutes = this.setParentsActive(newRoutes);

      return { mainRoutes: newRoutes, show: false };
    });
  };

  renderNavChildren = (routes: Array<Route>) => {
    if (BaseService.hasProfile()) {
      return routes
        .filter((route: Route) => Role.CheckRoles(route.allowedRoles))
        .map((route: Route) => (
          <NavItem
            toggleActiveChild={this.updateActiveRoutes}
            key={route.name}
            route={route}
            small={false}
            show={true}
            toggleSidebar={this.props.toggleSidebar}
          />
        ));
    }

    return null;
  };

  render() {
    let isAutoAutho = false;
    const routes = [
      RouteDefinitions.autoautho,
      RouteDefinitions.tutorial.AutoAuthoTutorial,
      RouteDefinitions.tutorial.SWOStatusTutorial
    ];
    if (
      routes.some(route => {
        return this.props.location.pathname.indexOf(route) >= 0;
      })
    ) {
      isAutoAutho = true;
    }
    return (
      <nav className={classes.nav}>
        <ol>
          <Link to={isAutoAutho ? getRoute(RouteDefinitions.autoautho) : getRoute(RouteDefinitions.dashboard)}>
            <li className={classes.logo} onClick={() => this.setInactive(this.state.mainRoutes)}>
              <div className={classes.image} />
            </li>
          </Link>
          {this.renderNavChildren(this.state.mainRoutes)}
        </ol>
        <div className={classes.logout}>
          <Logout />
        </div>
      </nav>
    );
  }
}
export const Sidedrawer = withRouter(SidedrawerComponent);



// WEBPACK FOOTER //
// ./src/side-drawer/side-drawer.component.tsx